export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";

export const AUTH_CLEAR_ERRORS = "AUTH_CLEAR_ERRORS";

export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT"

export const AUTH_REFETCHING = "AUTH_REFETCHING";
export const AUTH_REFETCHING_SUCCESS = "AUTH_REFETCHING_SUCCESS";
export const AUTH_REFETCHING_FAIL = "AUTH_REFETCHING_FAIL";



